import { Box, Button, Grid } from '@material-ui/core';
import { AttachFileTwoTone, ListAltOutlined, ViewListOutlined } from "@material-ui/icons";
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from "../../../utils/axios";
import { formatNumberSeparatedByCommas } from '../../../utils/strings/Localization';
import { getPermissionArray } from "../../../utils/strings/userString";
import DividendTable from './Table';
import UploadModal from './Uploader/UploadModal';
import ViewModal from './ViewModal';

function 
FilterTableComponent() {
  const permissionArray = getPermissionArray();
    const [showPageSize, setShowPageSize] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [numberOfPage, setNumberOfpage] = useState(1)
    const [dataStore, setDataStore] = useState([]);
    // const [inwardDividendSummary, setInwardDividendSummary] = useState()
    // const [rowsAffected, setRowsAffected] = useState()
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    // const { t } = useTranslation();

    const [openPreview, setOpenPreview] = useState(false);
    const [filePreview, setFilePreview] = useState('');
    
  const [opened, setOpened] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [typeOfTheDividend, setTypeOfTheDividend] = useState('');

  const [openView, setOpenView] = useState(false);
  const [selectedDividendId, setSelectedDividendId] = useState(null);
  // const [issuerId, setIssuerId] = useState('');
  // const [inwardDividendId, setInwardDividendId] = useState('');
  const [modalType, setModalType] = useState('');


  // const user = localStorage.getItem('user-name')
  // const userFormatted = JSON.parse(user);
  // const userType = userFormatted.userTypes[0];


  const savedFilters = JSON.parse(
  sessionStorage.getItem("inwardDividendFilters") || "{}"
);

const [filters, setFilters] = useState({
  issuerValue: savedFilters.issuerValue || "",
  dividendTypeValue: savedFilters.dividendTypeValue || "",
  statusValue: savedFilters.statusValue || "",
  remarksValue: savedFilters.remarksValue || "",
  startDate: savedFilters.startDate || null,
  endDate: savedFilters.endDate || null,

  totalCashLower: savedFilters.totalCashLower || "",
  totalCashUpper: savedFilters.totalCashUpper || "",

  totalFCLower: savedFilters.totalFCLower || "",
  totalFCUpper: savedFilters.totalFCUpper || "",

  totalStockLower: savedFilters.totalStockLower || "",
  totalStockUpper: savedFilters.totalStockUpper || "",
});

 const [anchorEl, setAnchorEl] = useState(null);
 const [hoveredRow,setHoveredRow] = useState(null);


const handlePopoverOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setHoveredRow(row.original);
};

const handlePopoverClose = () => {
  setAnchorEl(null);
  setHoveredRow(null);
};



const openPopOver = Boolean(anchorEl);

const HoverContainedButton = styled(Button)(({color }) => {
  return {
    cursor: "pointer",
    borderColor: color,
    color: color,
    backgroundColor: "transparent",
    transition: "all 0.25s ease-in-out",
    padding:"1px",
    "&:hover": {
      transform: "scale(1.05)",
      backgroundColor: `${color} !important`, // fill background
      color: '#fff', // white text
      borderColor: color, // match border
      boxShadow: 2,
    }
  };
});



useEffect(() => {
  sessionStorage.setItem(
    "inwardDividendFilters",
    JSON.stringify(filters)
  );
}, [filters]);
  
    const controlModal = (e) => {
      // console.log(e)
        setOpened((prevState) => !prevState);
        setTypeOfTheDividend(e.dividendType);
         setModalData(e);
    };

    const closeModal = () => {
        setOpened((prevState) => !prevState);
    };
const getDividendList = async (paramsData) =>{
        try{
            setLoading(true);
            const response = await axios.post(`inward-dividend/list`,paramsData);
            setDataStore(response.data.payload.payload)
            setCurrentPage(1);
            if(response.data?.payload.page){
                setNumberOfpage(Math.ceil(response.data.payload.total/showPageSize))
            }
      }
      catch (error) {
                  console.error(error);
                } finally {
                  setLoading(false);
                }
    }
    useEffect(() =>{
      
    getDividendList();
        
    },[])
    // [inwardDividendSummary,rowsAffected])


    // console.log(typeOfTheDividend)
    
    const paramsData = {
      page: currentPage,
      take: showPageSize,
  }
  //console.log(dataStore);

    // const deleteHandler = (id) => {
    //     Swal.fire({
    //       title: t('common.sweetAlert.sure'),
    //         text: t('common.sweetAlert.unDone'),
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: t('common.sweetAlert.yesDelete'),
    //         cancelButtonText: t('common.sweetAlert.noCancel'),
    //         reverseButtons: true
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             axios.delete(`/inward-dividend/${id}`)
    //                 .then((res) => {
    //                   axios.post(`inward-dividend/list`,paramsData)
    //                   .then((res) =>{
    //                       setDataStore(res.data.payload)
    //                       if(res.data?.page){
    //                           setNumberOfpage(Math.ceil(res.data?.total/showPageSize))
    //                       }
    //                   })
    //                   .catch((err) =>{
    //                   })
    //                 })
    //                 .catch((err) => {
    //                   alert("There was an error occured!")
    //                 });
    //         } else if (result.dismiss === Swal.DismissReason.cancel) {
    //             Swal.fire(
    //               t('common.sweetAlert.cancelled'),
    //                 t('common.sweetAlert.safe'),
    //                 'error'
    //             );
    //         }
    //     });
    //   }
    const handleViewClick = (id) => {
        // Swal.fire({
        //   title: t('common.sweetAlert.sure'),
        //   text: t('common.sweetAlert.viewConfirm'),
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonText: t('common.sweetAlert.yesView'),
        //   cancelButtonText: t('common.sweetAlert.noCancel'),
        //   //reverseButtons: true
        // }).then((result) => {
        //   if (result.isConfirmed) {
            history.push(`/app/inward-dividend/views/${id}`);
        //   }
        // })
        // setOpenView(true);
        // setSelectedDividendId(id);
        // setModalType('view');
      };
    const handleInvestorsDetails = (id) => {
        // Swal.fire({
        //   title: t('common.sweetAlert.sure'),
        //   text: t('common.sweetAlert.viewInvestorsDetails'),
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonText: t('common.sweetAlert.yesView'),
        //   cancelButtonText: t('common.sweetAlert.noCancel'),
        //   //reverseButtons: true
        // }).then((result) => {
        //   if (result.isConfirmed) {
            history.push(`/app/inward-dividend/investor-informations/${id}`);
        //   }
        // })
        // setOpenView(true);
        // setSelectedDividendId(id);
        // setModalType('investors_list');
      };

    // const handleEditInwardDividend = (id) => {
    //     Swal.fire({
    //       title: t('common.sweetAlert.sure'),
    //       text: t('common.sweetAlert.editConfirm'),
    //       icon: 'warning',
    //       showCancelButton: true,
    //       confirmButtonText: t('common.sweetAlert.yesEdit'),
    //       cancelButtonText: t('common.sweetAlert.noCancel'),
    //       //reverseButtons: true
    //     }).then((result) => {
    //       if (result.isConfirmed) {
    //         history.push(`/app/inward-dividend/edit/${id}`);
    //       }
    //     })
    //   };

    //   const inwardDivIssuerApproveHandler= (id) =>{
    //     // console.log(id);
    //     Swal.fire({
    //       title: 'Are you sure to Submit this Dividend to CMSF? ',
    //         text: 'Please remember that this can not be undone. You will not be able to edit or upload investors list after submission',
    //         icon: 'warning',
    //       //  footer: 'you will not be able to edit or upload investors list after submission',
    //         showCancelButton: true,
    //         cancelButtonColor: "#DC143C", 
    //         confirmButtonColor: "#527853",    
    //         confirmButtonText: 'Yes, Sure',
    //         cancelButtonText: t('common.sweetAlert.noCancel'),
    //         //reverseButtons: true
    //     }).then((result) => {
    //         if (result.isConfirmed) 
    //         {
    //           axios.put(`inward-dividend/update-status-inward-dividend/${id}`,{status: 1})
    //           .then(res => {
    //             if(res.data.statusCode === 200){
    //               setRowsAffected(res.data.payload.affected)
    //             // console.log(inwardDividendSummary)
    //             // console.log(res.data.payload.affected);
    //             if(res.data.payload.affected !==0)Swal.fire('Submitted to CMSF');
    //             else Swal.fire('Please check again');
    //           }
    //             else Swal.fire('Something went wrong');
    //           })
    //         .catch(err=>Swal.fire(err.response.data.errorMessages[0])
    //         )
    //       } 
    //       else if (result.dismiss === Swal.DismissReason.cancel) {
    //            Swal.fire(
    //              'No changes have been made',  
    //            );
    //        }
    //    });
    //   };
      // console.log(inwardDividendSummary)

      // const approveHandler = (id) =>{
      //   Swal.fire({
      //     title: t('common.sweetAlert.sure'),
      //       text: 'Are you sure to Approve this Inward Dividend? remember that this can not be undone. ',
      //       icon: 'warning',
      //       showCancelButton: true,
      //       cancelButtonColor: "#DC143C", 
      //       confirmButtonColor: "#527853",    
      //       confirmButtonText: 'Yes, Sure',
      //       cancelButtonText: t('common.sweetAlert.noCancel'),
      //       //reverseButtons: true
      //   }).then((result) => {
      //       if (result.isConfirmed) 
      //       {
      //       axios.put(`inward-dividend/update-status-inward-dividend/${id}`,{status: 2})
      //         .then(res => {
      //           setInwardDividendSummary(res.data.payload)
      //           //if(res.data.payload.affected !== 0)Swal.fire('Dividend Approved')
      //           Swal.fire('Dividend Approved')
      //           //else Swal.fire("You can't approve at this moment", 'Issuer must approve it first');
      //         })
      //       .catch(err=>Swal.fire(err.response.data.errorMessages[0])
      //       )
      //     } 
      //          else if (result.dismiss === Swal.DismissReason.cancel) {
      //               Swal.fire(
      //                 'No changes have been made',  
      //               );
      //           }
      //       });
      //   }

      //   const declineHandler = (id) =>{
      //     Swal.fire({
      //       title: t('common.sweetAlert.sure'),
      //         text: 'Are you sure to Decline this Inward Dididend? remember that this can not be undone. ',
      //         icon: 'warning',
      //         showCancelButton: true,
      //         cancelButtonColor: "#DC143C", 
      //         confirmButtonColor: "#527853",    
      //         confirmButtonText: 'Yes, Sure',
      //         cancelButtonText: t('common.sweetAlert.noCancel'),
      //         //reverseButtons: true
      //     }).then((result) => {
      //         if (result.isConfirmed) 
      //         {
                
      //         axios.put(`inward-dividend/update-status-inward-dividend/${id}`,{status: 4})
      //           .then(res => {
      //             setInwardDividendSummary(res.data.payload)
      //             Swal.fire(
      //               'Dividend Declined',  
      //             )
      //           })
      //         .catch(err=>Swal.fire(err.response.data.errorMessages[0])
      //         )
      //       } 
      //            else if (result.dismiss === Swal.DismissReason.cancel) {
      //                 Swal.fire(
      //                   'No changes have been made',  
      //                 );
      //             }
      //         });
      //     }
        //const totalCashSum = dataStore.reduce((sum, item) => sum + (item.total_cash || 0), 0);
        //const roundedTotalCash = parseFloat(totalCashSum.toFixed(3));
        //console.log("Total Cash:", roundedTotalCash);

       // const totalStockSum = dataStore.reduce((sum, item) => sum + (item.total_stock || 0), 0);
       // const roundedTotalStock = parseFloat(totalStockSum.toFixed(3));
       // console.log("Total Stock:", roundedTotalStock);

                            const [openUploadModal, setOpenUploadModal] = useState(false);
                            const style = {
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              width: '60%',
                              bgcolor: 'background.paper',
                              border: '2px solid #eee',
                              boxShadow: '2px 2px 2px 2px #eee',
                              borderRadius: "10px",
                              p: 4
                            };
                    
                    
                            const handlePreviewClick = async (row) => {
                              try {
                                const fileUrlfromDB = row.original.images[0];  // Access the file URL from the row
                                const fileURLclean = fileUrlfromDB.replace(/^\["|"\]$/g, '');
                                const response = await axios.post(`/settlement/get-settlement-file/37`, { filename: fileURLclean },
                                  { responseType: 'blob' });
                                const file = new Blob([response.data], { type: 'application/pdf' });
                                const fileUrl = URL.createObjectURL(file);
                    
                    
                                if (fileUrl) {
                                  setFilePreview(fileUrl); // Set the file preview URL
                                }
                                setOpenPreview(true);
                              }
                              catch (error) {
                                console.error("Error fetching PDF:", error);
                                setModalType('file_upload');
                                setSelectedDividendId(row.original.id);
                                // console.log('For Issuer ',row.original);
                                // setInwardDividendId(row.original.id);
                                setModalData(row.original);
                                setTypeOfTheDividend(row.original.dividendType);
                                // Check if the error is a 404 Not Found
                                if (error.response && error.response.status === 404) {
                                  Swal.fire({
                                    icon: "warning",
                                    title: "404 File Not Found",
                                    text: "The requested PDF file was not uploaded on the server. Please upload the file to view it.",
                                  }).then(() => {
                                    
                                    setOpenUploadModal(true);
                                  });
                                } else {
                                  // Handle other errors
                                  setModalType('file_upload');
                                    setSelectedDividendId(row.original.id);
                                    setModalData(row.original);
                                setTypeOfTheDividend(row.original.dividendType);
                                  Swal.fire({
                                    icon: "warning",
                                    title: "File Not Found!",
                                    //text: "Something went wrong!",
                                    text: "The requested PDF file was not uploaded. Please upload the file to view it.",
                                  })
                                  .then(() => {
                                    
                                    setOpenUploadModal(true);
                                  });
                                }
                              }
                            };

                             const openModal = () => {
                              return (
                                <Modal
                                  aria-labelledby="transition-modal-title"
                                  aria-describedby="transition-modal-description"
                                  open={openPreview}
                                  onClose={() => setOpenPreview(false)}
                                  closeAfterTransition
                                  BackdropComponent={Backdrop}
                                  slots={{ backdrop: Backdrop }}
                                  slotProps={{
                                    backdrop: {
                                      timeout: 500,
                                    }
                                  }}
                                  style={{
                                    overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", borderRadius: "10px"
                                  }}
                                >
                                  <Fade in={openPreview}>
                                    <Box sx={style} style={{ textAlign: "center", width: "80%", height: "95vh" }} >
                                      <h3>PDF VIEWER </h3>
                    
                    
                    
                                      <Box className="form-control" style={{ textAlign: "center", height: "90%" }}>
                    
                                        {
                                          // filePreview ? 
                    
                                          filePreview ? (
                                            <embed src={filePreview} width="100%" height="93%" type="application/pdf" />
                                          )
                                            :
                                            (
                                              <div
                                                style={{
                                                  alignItems: 'center',
                                                  border: '2px dashed rgba(0, 0, 0, .3)',
                                                  fontSize: '2rem',
                                                  height: '100%',
                                                  display: "flex",
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                  marginBottom: "5px"
                                                }}
                                              >
                                                View Area<br />
                                                Oops! The file is not uploaded yet.
                                              </div>
                                            )
                                        }
                    
                    
                                        <Button type="button" onClick={() => { setOpenPreview(false); }} variant="contained" color="primary" style={{ color: "white" }}><CloseIcon /> Close</Button>
                                      </Box>
                    
                    
                    
                                    </Box>
                                  </Fade>
                                </Modal>
                              )
                            }

    const columns = React.useMemo(
        () => [
            // {
                // Header: 'Inward Dividend Table',
                // columns: 
                // [
                    
                    {
                      Header: 'SL',
                      id: 'serial',
                      Cell: ({ row }) => {
                        // Calculates position based on currentPage (1-indexed) and showPageSize
                        // console.log(currentPage,showPageSize)
                        const serialNumber = (currentPage-1 ) * showPageSize + row.index + 1;
                        return <>{serialNumber}</>;
                      },
                    },
                    {
                        Header: 'ID',
                        accessor: 'autoId',
                        
                    },
                    {
                      Header: 'Date',
                      accessor: 'createdAt',
                      Cell: ({ value }) => {
                          const date = new Date(value);
                          return <>{date.toLocaleDateString("en-GB")}</>;
                        },
                  },
                    {
                        Header: 'Issuer',
                        accessor: 'issuer.name'
                    },
                    {
                      Header: 'Dividend Type',
                      accessor: 'dividendType',
                      
                    },
                    
                    {
                      Header: 'Dividend Year',
                      accessor: 'year'
                    },
                     
                    // {
                    //   Header: 'Total Cash',
                    //   accessor: 'total_cash',
                    //   Cell: ({ value }) => {
                    //     return <>{formatNumberSeparatedByCommas(value.toFixed(3))}</>;
                    //   },
                    // },
                    
                    // {
                    //     Header: 'Total FC',
                    //     accessor: 'total_fc'
                    // },
                    // {
                    //     Header: 'Total Stock',
                    //     accessor: 'total_stock',
                    //     Cell: ({ value }) => {
                    //     return <>{formatNumberSeparatedByCommas(value.toFixed(3))}</>;
                    //   },
                    // },
                    {
                        Header: 'Total Amount / Stock',
                        // Use a custom accessor or generic field name
                        id: 'dividend_amount', 
                        Cell: ({ row }) => {
                          // Get the dynamic type (handle potential lowercase/uppercase variations)
                          const type = row.original.dividendType?.toLowerCase() || '';
                          
                          // Extract values safely with fallback to 0
                          const totalCash = row.original.total_cash ?? 0;
                          const totalFC = row.original.total_fc ?? 0;
                          const totalStock = row.original.total_stock ?? 0;

                          // Conditionally check dividendType
                          if (type.includes('cash')) {
                            return <>&#2547; {formatNumberSeparatedByCommas(Number(totalCash).toFixed(3))}</>;
                          } 
                          
                          if (type.includes('fc') || type.includes('foreign')) {
                            return <>$ {formatNumberSeparatedByCommas(Number(totalFC).toFixed(3))}</>;
                          } 
                          
                          if (type.includes('stock') || type.includes('bonus')) {
                            return <>{formatNumberSeparatedByCommas(Number(totalStock).toFixed(3)) } Nos</>;
                          }

                          // Default fallback if type doesn't explicitly match
                          return <>N/A</>;
                        },
                      },
                    // {
                    //   Header: 'Payment Date',
                    //   accessor: 'date',
                    //   Cell: ({ value }) => value ? value.split('T')[0] : ''
                    // }
                    // {
                    //   Header: 'Payment Date',
                    //   accessor: 'date',
                    //   Cell: ({ value }) => {
                    //     if (!value) return '';
                    //     const [year, month, day] = value.split('T')[0].split('-');
                    //     return `${day}/${month}/${year}`;
                    //   }
                    // },  
                    // {
                    //     Header: 'Remarks',
                    //     accessor: 'remarks',
                    //     Cell: ({ row }) => {
                    
                    //         return (
                    //           <>
                    //               <Tooltip title={row.original.remarks}>
                    //                 <Typography
                    //                     noWrap
                    //                     sx={{
                    //                         maxWidth: 180,
                    //                         cursor: "pointer"
                    //                     }}
                    //                 >
                    //                     {row.original.remarks}
                    //                 </Typography>
                    //               </Tooltip>
                                                              
                    //           </>
                    //         );
                    //       },
                    // },
                    // {
                    //   Header: 'Current Status',
                    //   accessor: 'status',
                    //   Cell: ({row}) => 
                    //   <>
                    //     {row.values.status === 0 ? (
                    //            'Initiated'
                    //          ) : row.values.status === 1 ? 
                    //          (
                    //             `Approved by Issuer`

                    //          ) : row.values.status === 2 ? (
                    //             `Approved by CMSF`

                    //          ) : row.values.status === 4 ? (
                    //              `Cancelled by CMSF`

                    //         ) :  (
                    //             <> </>
                    //         )}
                    //   </>
                    //     },
                        {
                          accessor: "images",
                          Header: "Fwd Letter",
                          size: 40,
                          Cell: ({ row }) => {
                    
                            return (

                              
                                <HoverContainedButton variant="outlined" onClick={()=>handlePreviewClick(row)}
                                // style={{
                                //    backgroundColor: '#50C878',
                                //    color: '#50C878',
                                //   fontSize: '13px',
                                //   fontWeight: 'bold',
                                //    borderColor:'#50C878'
                                  
                                // }}
                                color='#1976d2'
                                // color='#50C878'
                                size='small'
                                aria-owns={openPopOver ? 'mouse-over-popover' : undefined}
                                aria-haspopup="true"
                                onMouseEnter={(e) => handlePopoverOpen(e, row)}
                                onMouseLeave={handlePopoverClose}
                                >
                                  View
                                </HoverContainedButton>
                            );
                          },
                        },      
                    {
                        Header: 'Actions',
                        accessor: 'issuerid',
                        Cell: ({row}) => <>
                        {/* the first button (enlarged view of the entry) comes default with the list */}
                         <Button
                         style={{margin: '2px',minWidth:"30px", maxWidth:"30px", height:"30px"}} size="small" title='Inward Dividend Details' variant="contained" color="primary" 
                         onClick={e=>handleViewClick(row.original.id)}
                        > <ViewListOutlined /></Button>
                        
                        <Button
                        disabled={!permissionArray.includes("Inward-Dividend-list-sub-investor-details")}
                         style={{margin: '2px', maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px'}} size="small" title='Investors List Details' variant="contained" color="primary" 
                         onClick={e=>handleInvestorsDetails(row.original.id)}
                        ><ListAltOutlined /> </Button>


                        <Button 
                        disabled={
                                    !permissionArray.includes("Inward-Dividend-list-sub-file-upload") ||
                                    [1, 2, 4].includes(row.original.status)
                                  }
                        style={{margin: '2px', maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px'}} color="primary" size="small" title='Investor Excel File Upload' variant="contained"  
                        onClick={()=>controlModal(row.original)}
                         >
                        
                        <AttachFileTwoTone />
                        </Button>

                        

                        {/* {(userType === 'Super_Admin' || userType === 'Admin_CMSF' )&& 
                        <>
                          <Button 
                          // disabled={!permissionArray.includes("Inward-Dividend-list-sub-file-upload")}
                            style={{margin: '2px', maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }} color="primary" size="small" title='Approve Dividend' variant="contained"  
                            onClick={()=>approveHandler((row.original.id))} 
                            disabled={row.original.status===2 || row.original.status===4}
                            >
                            
                            <DoneAllIcon />
                          </Button>

                          <Button
                            disabled={!permissionArray.includes("Inward-Dividend-list-sub-delete")}
                            style={{margin: '2px', maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px'}} size="small" title='Decline Dividend' variant="contained" color="secondary" 
                            onClick={()=>declineHandler(row.original.id)}
                            disabled={row.original.status===2 || row.original.status===4}>
                            <CancelRounded  /> 
                        </Button>
                        </>
                        } */}

                        {/* {userType === 'Issuer' && 
                        <>
                          <Button
                          disabled={!permissionArray.includes("Inward-Dividend-list-sub-edit")||(row.original.status===1 ||row.original.status===2 ||row.original.status===4)}
                          style={{margin: '2px', maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px'}} size="small" title='Edit' variant="contained" color="primary" 
                          onClick={e=>handleEditInwardDividend(row.original.id)}
                          
                          ><EditTwoTone  /> 
                        </Button>
                        <Button
                            disabled={!permissionArray.includes("Inward-Dividend-list-sub-delete")}
                            style={{margin: '2px', maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px',backgroundColor: "#7A9D54"}} size="small" title='Submit to CMSF' variant="contained" color="secondary" 
                            onClick={()=>inwardDivIssuerApproveHandler(row.original.id)}
                            disabled={(row.original.status===1 || row.original.status===2|| row.original.status===4)}>
                            <SendIcon />
                          </Button>
                          </>
                          } */}
                          

                        
                        </>
                    },
                    
                    
                // ],
            // },
        ],
        [currentPage, showPageSize]
    )

 

    return (
        <>
            <Grid>
                <DividendTable 
                showPageSize={showPageSize} 
                setShowPageSize={setShowPageSize} 
                setNumberOfpage={setNumberOfpage} 
                numberOfPage={numberOfPage} 
                currentPage={currentPage} 
                setCurrentPage={setCurrentPage} 
                setDataStore={setDataStore} 
                columns={columns} 
                data={dataStore} 
                filters={filters}
                setFilters={setFilters}
                parentLoading={loading}
                //roundedTotalCash={roundedTotalCash}
               // roundedTotalStock={roundedTotalStock}
                />
           </Grid>
                <ViewModal open={openView} setOpen={setOpenView} selectedDividendId={selectedDividendId} closeModal={()=>setOpenView(false)} modalType={modalType}/>
                {/* <FileUploadModal open={opened} data={modalData} control={controlModal} typeOfTheDividend={typeOfTheDividend} closeModal={closeModal}/> */}
               { modalData && <UploadModal open={opened} data={modalData} control={controlModal} typeOfTheDividend={typeOfTheDividend} closeModal={closeModal} tabIndex={1}/>}

                 {openPreview && openModal()}

                 {
                  modalType === 'file_upload'
                  ?
                                   modalData && <UploadModal
                                      open={openUploadModal}
                                      closeModal={() => setOpenUploadModal(false)}
                                      data={modalData}
                                      typeOfTheDividend={typeOfTheDividend}
                                      tabIndex={0}
                                      onSubmit={() => {
                                        setOpenUploadModal(false);
                                        // Refresh the data after successful upload
                                        getDividendList(paramsData);
                                        }}
                                      />
                                    
                                    : null
                 }

                 <Popover
                      id="mouse-over-popover"
                      sx={{
                        pointerEvents: 'none', // Prevents popover from blocking onMouseLeave on the button
                      }}
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left', // Places popover directly underneath the button
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      onClose={handlePopoverClose}
                      disableRestoreFocus
                      PaperProps={{
                        style: {
                          width: '200px', // Set your custom target width here
                          padding: '8px',
                        },
                      }}
                    >
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        {hoveredRow?.remarks || "No remarks"}
                      </Typography>
                      {/* <Typography
                        variant="caption"
                        color="textSecondary"
                        style={{ display: 'block', textAlign: 'right', marginTop: '4px' }}
                      >
                        Last Checked: {hoveredRow?.updatedby || "N/A"}
                      </Typography> */}
                    </Popover>
                                  
        </> 
    )
}

export default FilterTableComponent;